import React from 'react';
import Page from "../component/Page/Page";
import CompanyConfigurationForm from './CompanyConfigurationForm';

class CompanyConfigurationFormPage extends React.Component {
  render() {
    const {match, history} = this.props;
    return (
      <Page title="Cadastro de Empresa">
        <CompanyConfigurationForm match={match} history={history}/>
      </Page>
    );
  }
}

export default CompanyConfigurationFormPage;


// WEBPACK FOOTER //
// ./src/CompanyConfigurations/CompanyConfigurationFormPage.js